import Vue from "vue"
import Vuex from "vuex"
import culture from "./modules/culture"
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    culture,
  },
})
